import { Skeleton, Tooltip, Typography } from "@mui/material"
import React from "react"

import { NumberFont } from "./RootLayout/fonts"
import { TokenAmountBlockProps } from "./TokenAmountBlock"
import { formatNumber } from "../utils/number-utils"
import { useTokenInfo } from "@/hooks/use-token-info"
import { formatNumberAuto } from "@/utils/format"

export function ConvertedAmountBlock(props: TokenAmountBlockProps) {
  const { amount, needsParsing, tokenId, quoteTokenUsdPrice } = props
  const [tokenInfo] = useTokenInfo(tokenId)

  if (quoteTokenUsdPrice === undefined)
    return <Skeleton component="span" sx={{ display: "inline-flex" }} width={80} />
  if (quoteTokenUsdPrice === null) return "-"

  let amountNumber = Number(amount) * quoteTokenUsdPrice
  const decimals = amountNumber !== 0 && tokenInfo ? tokenInfo.denomination : 0
  const usdDecimals = amountNumber !== 0 ? 3 : 0

  if (needsParsing) amountNumber = amountNumber / 10 ** decimals

  const longValue = formatNumber(amountNumber, {
    minimumFractionDigits: usdDecimals,
    maximumFractionDigits: 18,
  })

  return (
    <Typography fontFamily={NumberFont} component="span" variant="inherit">
      <Tooltip
        title={
          <Typography fontFamily={NumberFont} component="span" variant="inherit">
            <span>{longValue} USD</span>
          </Typography>
        }
      >
        <span>${formatNumberAuto(amountNumber, 3)}</span>
      </Tooltip>
    </Typography>
  )
}
